import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';

@Component({
  selector: 'ui-app-shell',
  imports: [],
  templateUrl: './ui-app-shell.component.html',
  styleUrl: './ui-app-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiAppShellComponent {
  public readonly hasTabbar: InputSignal<boolean> = input<boolean>(true);
  public readonly ariaLabel: InputSignal<string> = input<string>('Application');
}
